
// ============================================
// 配置：写死的渠道ID
// 可选值: 'default' | 'channel_a' 
// ============================================
export const CHANNEL_ID = 'channel_d'
const CHANNEL_IMAGE_PATHS = {
  default: 'new_slices',// 默认公司渠道
  channel_a: 'channel_a',//廊坊市诚睿工程咨询有限公司
  channel_b: 'channel_b',//河北网嘉招采交易平台
  channel_c: 'channel_c',//诚易招x
  channel_d: 'channel_d',//河北广跃
}
const CHANNEL_MATERIALS = {
  // 默认渠道
  default: {
    channelCode: '',
    companyName: '诚易招',
    title: '诚易招电子招投标',
    favicon: 'favicon.png',
    mqttScriptUrl: 'https://unpkg.com/mqtt/dist/mqtt.min.js',
    headerLogo: {
      fileName: 'logo.png'
    },
    headerBgImage: {
      fileName: ''
    },
    // 顶部 tabbar 颜色
    tabbarColor: '',
    headerLogoStyle: {
      width: '80px',
      height: '27px'
    },
    phone: '400-963-5558',
    email: 'xiancheng@xc-hbtech.com',
    banner: {
      fileName: 'banner.png'
    },
    loginBg: {
      fileName: 'role_bg@2x.png'
    },
    tbLoginImg: {
      fileName: 'bidder@2x.png'
    },
    zbLoginImg: {
      fileName: 'tenderer@2x.png'
    },
    dLLoginImg: {
      fileName: 'Bidding Agency@2x.png'
    },
    zjLoginImg: {
      fileName: 'expert@2x.png'
    },
    roleLoginTexts: {
      bidder: '投标人登录',
      tenderee: '招标人登录',
      agent: '招标代理登录',
      evaluation: '评标系统'
    },
    roleLoginBgStyle: {
      width: '285px',
      height: '409px'
    },
    roleLoginTextsImg: {
      bidder: '',//投标人登录图片
      tenderee: '',//招标人登录图片
      agent: '',//招标代理登录图片
      evaluation: '',//评标系统图片
    },
    adLogo: {
      fileName: 'logo2.png'
    },
    adPageTextImg: {
      fileName: ''
    },
    loginLogo: {
      fileName: 'logo2@2x.png'
    },
    footer: {
      logo: { fileName: 'logo3.png' },
      logoStyle: {
        width: '80px',
        height: '27px'
      },
      address: '河北省石家庄市裕华区天山大街澳怡大厦16楼',
      phone: '400-963-5558',
      icp: '冀ICP备2025138489号-1'
    },
  },
  // 渠道A
  channel_a: {
    channelCode: 'LF00eded0baa01X',
    companyName: '廊坊市诚睿工程咨询有限公司',
    title: '诚睿招',
    favicon: 'Afavicon.png',
    mqttScriptUrl: '', // 渠道A不需要MQTT
    headerLogo: {
      fileName: 'ad 2.png'
    },
    headerBgImage: {
      fileName: ''
    },
    // 顶部 tabbar 颜色
    tabbarColor: '',
    headerLogoStyle: {
      width: '150px',
      height: '40px'
    },
    phone: '0316-2235849',
    email: 'lfchengrui@126.com',
    banner: {
      fileName: 'banner.jpg'
    },
    loginBg: {
      fileName: 'role_bg@2x.png'
    },
    tbLoginImg: {
      fileName: 'bidder@2x.png'
    },
    zbLoginImg: {
      fileName: 'tenderer@2x.png'
    },
    dLLoginImg: {
      fileName: 'Bidding Agency@2x.png'
    },
    zjLoginImg: {
      fileName: 'expert@2x.png'
    },
    roleLoginTexts: {
      bidder: '',
      tenderee: '',
      agent: '',
      evaluation: ''
    },
    roleLoginBgStyle: {
      width: '355px',
      height: 'auto',
    },
    roleLoginTextsImg: {
      bidder: '',//投标人登录图片
      tenderee: '',//招标人登录图片
      agent: '',//招标代理登录图片
      evaluation: '',//评标系统图片
    },
    adLogo: {
      fileName: ''
    },
    adPageTextImg: {
      fileName: ''
    },
    loginLogo: {
      fileName: 'ad 2.png'
    },
    footer: {
      logo: { fileName: 'ad.png' },
      logoStyle: {
        width: '150px',
        height: '40px'
      },
      address: '河北省廊坊市安次区廊坊龙河高新技术产业开发区富康道89号1号电子厂房909-912室',
      phone: '0316-2235681',
      icp: ''
    },
  },
  // 渠道b
  channel_b: {
    channelCode: 'WJ00eduk9bba99H',
    companyName: '河北网嘉',
    title: '河北网嘉招采交易平台',
    favicon: 'Bfavicon.png',
    mqttScriptUrl: '',
    headerLogo: {
      fileName: 'logo2.png'
    },
    headerBgImage: {
      fileName: ''
    },
    // 顶部 tabbar 颜色
    tabbarColor: '',
    headerLogoStyle: {
      width: '80px',
      height: '27px'
    },
    phone: '400-963-5558',
    email: 'xiancheng@xc-hbtech.com',
    banner: {
      fileName: 'banner.png'
    },
    loginBg: {
      fileName: 'role_bg@2x.png'
    },
    tbLoginImg: {
      fileName: 'bidder@2x.png'
    },
    zbLoginImg: {
      fileName: 'tenderer@2x.png'
    },
    dLLoginImg: {
      fileName: 'Bidding Agency@2x.png'
    },
      zjLoginImg: {
      fileName: 'expert@2x.png'
    },
    roleLoginTexts: {
      bidder: '投标人登录',
      tenderee: '招标人登录',
      agent: '招标代理登录',
      evaluation: '评标系统'
    },
    roleLoginBgStyle: {
      width: '285px',
      height: '409px'
    },
    roleLoginTextsImg: {
      bidder: '',//投标人登录图片
      tenderee: '',//招标人登录图片
      agent: '',//招标代理登录图片
      evaluation: '',//评标系统图片
    },
    adLogo: {
      fileName: 'adLogo.png'
    },
    adPageTextImg: {
      fileName: ''
    },
    loginLogo: {
      fileName: 'logo2.png'
    },
    footer: {
      logo: { fileName: 'logo2.png' },
      logoStyle: {
        width: '80px',
        height: '27px'
      },
      address: '河北省石家庄桥西区裕华西路110号',
      phone: '400-963-5558',
      icp: ''
    },
  },
  // 渠道C
  channel_c: {
    channelCode: 'XXX89sdfkk88999',
    companyName: '诚易招',
    title: '诚易招电子招投标',
    favicon: 'favicon.png',
    mqttScriptUrl: 'https://unpkg.com/mqtt/dist/mqtt.min.js',
    headerLogo: {
      fileName: 'logo.png'
    },
    headerBgImage: {
      fileName: ''
    },
    // 顶部 tabbar 颜色
    tabbarColor: '',
    headerLogoStyle: {
      width: '80px',
      height: '27px'
    },
    phone: '400-963-5558',
    email: 'xiancheng@xc-hbtech.com',
    banner: {
      fileName: 'banner.png'
    },
    loginBg: {
      fileName: 'role_bg@2x.png'
    },
    tbLoginImg: {
      fileName: 'bidder@2x.png'
    },
    zbLoginImg: {
      fileName: 'tenderer@2x.png'
    },
    dLLoginImg: {
      fileName: 'Bidding Agency@2x.png'
    },
    zjLoginImg: {
      fileName: 'expert@2x.png'
    },
    roleLoginBgStyle: {
      width: '285px',
      height: '409px'
    },
    roleLoginTexts: {
      bidder: '投标人登录',
      tenderee: '招标人登录',
      agent: '招标代理登录',
      evaluation: '评标系统'
    },
    roleLoginTextsImg: {
      bidder: '',//投标人登录图片
      tenderee:  '',//招标人登录图片
      agent:  '',//招标代理登录图片
      evaluation:  '',//评标系统图片
    },
    adLogo: {
      fileName: 'logo2.png'
    },
    adPageTextImg: {
      fileName: ''
    },
    loginLogo: {
      fileName: 'logo2@2x.png'
    },
    loginBgStyle: {
    },
    footer: {
      logo: { fileName: 'logo3.png' },
      logoStyle: {
        width: '80px',
        height: '27px'
      },
      address: '河北省石家庄市裕华区天山大街澳怡大厦16楼',
      phone: '400-963-5558',
      icp: '冀ICP备2025138489号-1'
    },
  },

  // 渠道D
  channel_d: {
    channelCode: 'GYZC20260724001',
    companyName: '广跃智诚',
    title: '广跃智诚',
    mqttScriptUrl: 'https://unpkg.com/mqtt/dist/mqtt.min.js',

    favicon: 'Dfavicon.png',
    // 首页广告图路径
    banner: {
      fileName: 'banner.jpg'
    },
    // 头部Logo路径
    headerLogo: {
      fileName: 'logo.png'
    },
    // 头部背景图片
    headerBgImage: {
      fileName: 'header_bg.jpg'
    },

    loginLogo: {
      fileName: 'logo.png'
    },
    // 顶部 tabbar 颜色
    tabbarColor: '#303C44',
    // 广告Logo路径
    adLogo: {
      fileName: 'adLogo.png'
    },
    // 广告页面 文件路径
    adPageTextImg: {
      fileName: 'adPageTextImg.png'
    },
    // 底部Logo路径
    footer: {
      logo: { fileName: 'adLogo.png' },
      logoStyle: {
        width: '100px',
        height: '27px'
      },
      address: '河北省石家庄市藁城区廉东北大街16号301室',
      phone: '400-963-5558',
      icp: ''
    },
    headerLogoStyle: {
      width: '100px',
      height: '27px'
    },
    loginBg: {
      fileName: 'role_bg@2x.png'
    },
    tbLoginImg: {
      fileName: 'toubiao.png'
    },
    zbLoginImg: {
      fileName: 'zhaobiao.png'
    },
    dLLoginImg: {
      fileName: 'daili.png'
    },
    zjLoginImg: {
      fileName: 'zhuanjia.png'
    },
    roleLoginBgStyle: {
      width: '225px',
      height: '225px'
    },
    //  背景图片宽高
    loginBgStyle: {
      // width: '1225px',
      // height: '255px'
    },
    roleLoginTexts: {
      bidder: '',
      tenderee: '',
      agent: '',
      evaluation: ''
    },
    roleLoginTextsImg: {
      bidder: 'toubiaoText.png',//投标人登录图片
      tenderee: 'zhaobiaoText.png',//招标人登录图片
      agent: 'dailiText.png',//招标代理登录图片
      evaluation: 'zhuanjiaText.png',//评标系统图片
    },
  },
}

// ============================================
// 素材管理类
// ============================================
class ChannelMaterialManager {
  constructor(channelId) {
    this.channelId = channelId || CHANNEL_ID
    this.materials = this.loadMaterials()
  }
  /**
   * 加载当前渠道的素材配置
   */
  loadMaterials() {
    const materials = CHANNEL_MATERIALS[this.channelId]
    if (!materials) {
      console.warn(`[ChannelMaterial] 渠道 "${this.channelId}" 不存在，使用默认配置`)
      return CHANNEL_MATERIALS.default
    }
    console.log(`[ChannelMaterial] 已加载渠道 "${this.channelId}" 的素材配置`)
    return materials
  }
  /**
   * 获取完整素材配置
   */
  getAll() {
    return this.materials
  }
  getImagePath(fileName) {
    const folderPath = CHANNEL_IMAGE_PATHS[this.channelId] || CHANNEL_IMAGE_PATHS.default
    const defaultFolderPath = CHANNEL_IMAGE_PATHS.default

    try {
      return require(`@/assets/image/${folderPath}/${fileName}`)
    } catch (error) {
      if (folderPath !== defaultFolderPath) {
        console.warn(`[ChannelMaterial] 渠道资源不存在，回退默认素材: ${folderPath}/${fileName}`)
        return require(`@/assets/image/${defaultFolderPath}/${fileName}`)
      }
      throw error
    }
  }
  //获取Banner背景图路径
  getBannerPath() {
    if (!this.materials.banner || !this.materials.banner.fileName) {
      console.warn(`[ChannelMaterial] Banner配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.banner.fileName)
  }
  //获取登录页背景图路径
  getLoginBgPath() {
    if (!this.materials.loginBg || !this.materials.loginBg.fileName) {
      console.warn(`[ChannelMaterial] 登录页背景图配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.loginBg.fileName)
  }
  //获取投标人登录图片路径
  tbLoginImg() {
    if (!this.materials.tbLoginImg || !this.materials.tbLoginImg.fileName) {
      console.warn(`[ChannelMaterial] 投标人登录图片配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.tbLoginImg.fileName)
  }
  //获取招标人登录图片路径
  zbLoginImg() {
    if (!this.materials.zbLoginImg || !this.materials.zbLoginImg.fileName) {
      console.warn(`[ChannelMaterial] 招标人登录图片配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.zbLoginImg.fileName)
  }
  //获取招标代理登录图片路径
  dLLoginImg() {
    if (!this.materials.dLLoginImg || !this.materials.dLLoginImg.fileName) {
      console.warn(`[ChannelMaterial] 招标代理登录图片配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.dLLoginImg.fileName)
  }
  //获取专家登录图片路径
  zjLoginImg() {
    if (!this.materials.zjLoginImg || !this.materials.zjLoginImg.fileName) {
      console.warn(`[ChannelMaterial] 专家登录图片配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.zjLoginImg.fileName)
  }
  // 获取角色登录文字配置
  getRoleLoginTexts() {
    return this.materials.roleLoginTexts || {
      bidder: '投标人登录',
      tenderee: '招标人登录',
      agent: '招标代理登录',
      evaluation: '评标系统'
    }
  }
  //获取角色登录背景图片宽高
  getRoleLoginBgStyle() { 
    return this.materials.roleLoginBgStyle || {
      width: '285px',
      height: '409px'   
    }
  }
  //获取角色登录图片配置
  getRoleLoginTextsImg() {
    const config = this.materials.roleLoginTextsImg
    if (!config) return {}
    const result = {}
    Object.keys(config).forEach((key) => {
      const fileName = config[key]
      result[key] = fileName ? this.getImagePath(fileName) : ''
    })
    return result
  }
  //获取公司名称
  getCompanyName() {
    return this.materials.companyName || '诚易招'
  }
  //获取头部Logo路径
  getHeaderLogoPath() {
    if (!this.materials.headerLogo || !this.materials.headerLogo.fileName) {
      console.warn(`[ChannelMaterial] 头部Logo配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.headerLogo.fileName)
  }
  getHeaderLogoStyle() {
    return this.materials.headerLogoStyle || {
      width: '80px',
      height: '27px'
    }
  }
  //获取头部背景图片路径
  getHeaderBgImagePath() {
    if (!this.materials.headerBgImage || !this.materials.headerBgImage.fileName) {
      console.warn(`[ChannelMaterial] 头部背景图片配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.headerBgImage.fileName)
  }
  //获取顶部 tabbar 颜色
  getTabbarColor() {
    return this.materials.tabbarColor
  }
  //获取咨询电话
  getPhone() {
    return this.materials.phone 
  }
  // 获取渠道码
  getChannelCode() {
    return this.materials.channelCode
  }

  //获取邮箱
  getEmail() {
    return this.materials.email 
  }
  //获取广告页面 文件路径
  getAdPageTextImgPath() {
    if (!this.materials.adPageTextImg || !this.materials.adPageTextImg.fileName) {
      console.warn(`[ChannelMaterial] 广告页面 文件路径配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.adPageTextImg.fileName)
  }

  //获取登录页Logo路径
  getLoginLogoPath() {
    if (!this.materials.loginLogo || !this.materials.loginLogo.fileName) {
      console.warn(`[ChannelMaterial] 登录页Logo配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.loginLogo.fileName)
  }

  //获取广告Logo路径
  getAdLogoPath() {
    if (!this.materials.adLogo || !this.materials.adLogo.fileName) {
      console.warn(`[ChannelMaterial] 广告Logo配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.adLogo.fileName)
  }

  //获取底部Logo路径
  getFooterLogoPath() {
    if (!this.materials.footer || !this.materials.footer.logo || !this.materials.footer.logo.fileName) {
      console.warn(`[ChannelMaterial] 底部Logo配置不存在`)
      return ''
    }
    return this.getImagePath(this.materials.footer.logo.fileName)
  }

  //获取底部公司地址
  getFooterAddress() {
    return (this.materials.footer && this.materials.footer.address) || ''
  }

  getFooterLogoStyle() {
    return (this.materials.footer && this.materials.footer.logoStyle) || {
      width: '80px',
      height: '27px'
    }
  }

  //获取底部联系电话
  getFooterPhone() {
    return (this.materials.footer && this.materials.footer.phone) || ''
  }

  //获取底部ICP备案号
  getFooterIcp() {
    return (this.materials.footer && this.materials.footer.icp) || ''
  }

  //获取页面标题
  getTitle() {
    return this.materials.title || '诚易招电子招投标'
  }

  //获取Favicon文件名
  getFavicon() {
    return this.materials.favicon || 'favicon.png'
  }

  /**
   * 设置页面Title和Favicon
   */
  setPageMeta(onMqttReady) {
    // 设置title
    const title = this.getTitle()
    document.title = title

    // 设置favicon
    const favicon = this.getFavicon()
    const faviconUrl = process.env.BASE_URL + favicon

    // 查找或创建favicon link标签
    let link = document.querySelector("link[rel*='icon']")
    if (!link) {
      link = document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      document.head.appendChild(link)
    }
    link.href = faviconUrl

    // 动态加载MQTT脚本（如果配置了）
    this.loadMqttScriptIfNeeded(onMqttReady)

    console.log(`[ChannelMaterial] 页面元数据已更新: title="${title}", favicon="${faviconUrl}"`)
  }

  /**
   * 动态加载MQTT脚本（根据渠道配置）
   * @param {function} onReady - 脚本加载成功后的回调
   */
  loadMqttScriptIfNeeded(onReady) {
    const mqttUrl = this.materials.mqttScriptUrl

    // 如果当前已存在MQTT脚本，先移除
    const existingScript = document.getElementById('dynamic-mqtt-script')
    if (existingScript) {
      existingScript.remove()
    }

    // 如果配置了MQTT URL，则动态加载
    if (mqttUrl) {
      const script = document.createElement('script')
      script.id = 'dynamic-mqtt-script'
      script.src = mqttUrl
      script.async = true
      script.onload = () => {
        console.log(`[ChannelMaterial] MQTT脚本加载成功: ${mqttUrl}`)
        if (typeof onReady === 'function') onReady()
      }
      script.onerror = () => {
        console.error(`[ChannelMaterial] MQTT脚本加载失败: ${mqttUrl}`)
      }
      document.body.appendChild(script)
    } else {
      console.log('[ChannelMaterial] 当前渠道未配置MQTT脚本，跳过加载')
      if (typeof onReady === 'function') onReady()
    }
  }

  /**
   * 获取当前渠道ID
   */
  getChannelId() {
    return this.channelId
  }

  /**
   * 切换渠道（用于动态切换）
   */
  switchChannel(channelId) {
    if (CHANNEL_MATERIALS[channelId]) {
      this.channelId = channelId
      this.materials = this.loadMaterials()
      return true
    }
    console.error(`[ChannelMaterial] 切换渠道失败，"${channelId}" 不存在`)
    return false
  }
}

// 创建单例实例
const channelMaterial = new ChannelMaterialManager(CHANNEL_ID)

// 默认导出管理器实例
export default channelMaterial

// 命名导出管理器类和常量
export { ChannelMaterialManager, CHANNEL_MATERIALS }
